module.exports = __webpack_public_path__ + "img/Picture5.bd908064.jpg";